export const longEnv = (env: string = "test") => {
  switch (env) {
    case "dev":
      return "development";
    case "prod":
      return "production";
    default:
      return env;
  }
};
